export default __webpack_public_path__ + "static/media/discord_icon.cd8aec7b.svg";